import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"
import Header from "../components/Header"
import { PageContentContainer } from "./styled"
import LinkingFlow from "./LinkingFlow"
import HomeFlow from "./HomeFlow"
import HistoryFlow from "./HistoryFlow"
import TransferFlow from "./TransferFlow"
import TransferFlowM2MFlow from "./M2MPullFlow"
import AuthFlow from "./AuthFlow"
import ProtectedRoute from "../components/ProtectedRoute"
import SettingsFlow from "./SettingsFlow"
import { ROUTES_PATHS } from "../utils/constants"
import InaccessibleRoute from "../components/InaccessibleRoute"
import M2MPushFlow from "./M2MPushFlow"
import ErrorPage from "../pages/ErrorPage"
import AuthErrorPage from "../pages/AuthErrorPage"
import C2CPushFlow from "./TransferFlow/C2CPushFlow"
import SettingsSBPFlow from "./SettingsFlow/SettingsSBPFlow"
import SettingsLimitsFlow from "./SettingsFlow/SettingsLimitsFlow"
import SettingsAllowedBanksFlow from "./SettingsFlow/SettingsSBPFlow/SettingsAllowedBanksFlow"
import QuitFlow from "./QuitFlow"
import OperationsHistoryFlow from "./OperationsHistoryFlow"
import PaymentFlow from "./PaymentFlow"
import { CitizenRestricted } from "../pages/CitizenRestricted"
import C2BPushFlow from "./C2BPushFlow"

const Router = () => (
  <BrowserRouter>
    <Header />
    <PageContentContainer>
      <Routes>
        <Route
          path="/"
          element={<ProtectedRoute component={<Navigate to="/main" />} />}
        />
        <Route
          path="/main"
          element={<ProtectedRoute component={<HomeFlow />} />}
        />
        <Route
          path={`/${ROUTES_PATHS.operationsHistory}/*`}
          element={<ProtectedRoute component={<OperationsHistoryFlow />} />}
        />
        <Route
          path={`/${ROUTES_PATHS.history}/*`}
          element={<ProtectedRoute component={<HistoryFlow />} />}
        />
        <Route
          path={`/${ROUTES_PATHS.linking}/*`}
          element={<ProtectedRoute component={<LinkingFlow />} />}
        />
        <Route
          path={`/${ROUTES_PATHS.withdraw}/*`}
          element={<ProtectedRoute component={<TransferFlow />} />}
        />
        <Route
          path={`/${ROUTES_PATHS.pushC2c}/*`}
          element={<ProtectedRoute component={<C2CPushFlow />} />}
        />
        <Route
          path={`/${ROUTES_PATHS.refill}/*`}
          element={<ProtectedRoute component={<TransferFlowM2MFlow />} />}
        />
        <Route
          path={`/${ROUTES_PATHS.settings}/*`}
          element={<ProtectedRoute component={<SettingsFlow />} />}
        />
        <Route
          path={`/${ROUTES_PATHS.sbpSettings}/*`}
          element={<ProtectedRoute component={<SettingsSBPFlow />} />}
        />
        <Route
          path={`/${ROUTES_PATHS.allowedBanks}/*`}
          element={<ProtectedRoute component={<SettingsAllowedBanksFlow />} />}
        />
        <Route
          path={`/${ROUTES_PATHS.limits}/*`}
          element={<ProtectedRoute component={<SettingsLimitsFlow />} />}
        />
        <Route path={`/${ROUTES_PATHS.auth}/*`} element={<AuthFlow />} />
        <Route
          path={`/${ROUTES_PATHS.topUpMbankAccount}/*`}
          element={<PaymentFlow />}
        />
        <Route path="citizen-restricted" element={<CitizenRestricted />} />
        <Route
          path={`/${ROUTES_PATHS.me2meAgreement}/*`}
          element={<ProtectedRoute component={<M2MPushFlow />} />}
        />
        <Route path={`/${ROUTES_PATHS.quit}/*`} element={<QuitFlow />} />
        <Route path={`/${ROUTES_PATHS.error}/*`} element={<ErrorPage />} />
        <Route
          path={`/${ROUTES_PATHS.authError}/*`}
          element={<AuthErrorPage />}
        />
        <Route
          path={`/${ROUTES_PATHS.qr}/*`}
          element={<ProtectedRoute component={<C2BPushFlow />} />}
        />
        <Route path="/*" element={<InaccessibleRoute />} />
      </Routes>
    </PageContentContainer>
  </BrowserRouter>
)

export default Router
